<script setup>
import BreezeButton from '@/Components/Button.vue';
import BreezeCheckbox from '@/Components/Checkbox.vue';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';

defineProps({
  canResetPassword: Boolean,
  status: String,
});

const form = useForm({
  email: '',
  password: '',
  remember: false
});

const submit = () => {
  form.post(route('login'), {
    onFinish: () => form.reset('password'),
  });
};
</script>

<template>

  <Head title="ログイン" />

  <BreezeGuestLayout>

    <section class="main login">
      <h2 class="login_title c-heading-h2">ログイン</h2>

      <BreezeValidationErrors class="mb-4" />

      <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
        {{ status }}
      </div>

      <form @submit.prevent="submit">
        <div class="c-input_row">
          <BreezeLabel for="password" value="メールアドレス" />
          <BreezeInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus autocomplete="username" />
        </div>

        <div class="c-input_row">
          <BreezeLabel for="password" value="パスワード" />
          <BreezeInput id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="current-password" />
        </div>

        <div class="c-input_row">
          <label class="flex items-center">
            <BreezeCheckbox name="remember" v-model:checked="form.remember" />
            <span class="">メアド・パスワードを保存する</span>
          </label>
        </div>

        <div>
          <BreezeButton class="c-button" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
            ログイン
          </BreezeButton>
          <Link v-if="canResetPassword" :href="route('password.request')" class="c_text-link">
            パスワードを忘れた方
          </Link>
          <Link :href="route('register')" class="c_text-link">
            新規登録はこちら
          </Link>
        </div>
      </form>
    </section>
  </BreezeGuestLayout>
</template>
